import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {TaggedAction} from "@common/domain/common.props";
import {ApplicationResponse, StateTrackedData, TaggedDataState} from "@common/domain/common.model";
import {ModelInfoDataModel, ModelsDataModel, ModelsStore} from "@views/master-data/domain/models.model";
import {UsersDataModel} from "@views/master-data/domain/users.model";
import api from "@common/services/api.service";
import ModelsInfoDialog from "@views/master-data/dialogs/models.info.dialog";

export const fetchModels = createAsyncThunk<ModelsDataModel[], void>("model/fetchModels",
    async () => {
        const response = await api.get<ApplicationResponse<ModelsDataModel[]>>("model")
        return response.data.data as ModelsDataModel[]
    })

export const fetchModelsInfo = createAsyncThunk<ModelInfoDataModel, { code: string }>("model/fetchModelsInfo",
    async ({code}) => {
        const response = await api.get<ApplicationResponse<ModelInfoDataModel>>(`model/${code}`)
        return response.data.data as ModelInfoDataModel
    }
)

export const updateModelStatus = createAsyncThunk<void, {model_id: string, count?: number, line_status: string}>("model/startProductionForModel",
    async (payload) => {
        const response = await api.post("line/update-status", payload)
        return response.data.data
    }
    )

const modelSlice = createSlice({
    name: "model",
    initialState: {
        modelsMinimal: {
            status: "loading",
            data: [],
            error: null
        } as StateTrackedData<ModelsDataModel[]>,
        modelsInfo: {
            status: "loading",
            data: {},
            error: null
        } as StateTrackedData<ModelInfoDataModel>
    } as ModelsStore,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchModels.pending, (state) => {
                state.modelsMinimal.status = "loading"
                state.modelsMinimal.error = null
                state.modelsMinimal.data = []
            }
        ).addCase(fetchModels.fulfilled, (state, action) => {
            state.modelsMinimal.status = "idle"
            state.modelsMinimal.data = action.payload
            state.modelsMinimal.error = null
        }).addCase(fetchModels.rejected, (state, action) => {
            state.modelsMinimal.status = "failed"
            state.modelsMinimal.error = action.error.message
            state.modelsMinimal.data = []
        })
        builder.addCase(fetchModelsInfo.pending, (state) => {
                state.modelsInfo.status = "loading"
                state.modelsInfo.error = null
                state.modelsInfo.data = {} as ModelInfoDataModel
        }).addCase(fetchModelsInfo.fulfilled, (state, action) => {
            state.modelsInfo.status = "idle"
            state.modelsInfo.data = action.payload
            state.modelsInfo.error = null
        }).addCase(fetchModelsInfo.rejected, (state, action) => {
            state.modelsInfo.status = "failed"
            state.modelsInfo.error = action.error.message
            state.modelsInfo.data = {} as ModelInfoDataModel
        })
    }

})

export default modelSlice.reducer